import Showcase from 'Vue/containers/Showcase.vue';
import { createApp } from "vue";

let module:any = {};

/**
 * Instantiate Vue Application
 */
module.addVueApp = function () {
	const showcases = createApp(Showcase);
	showcases.mount("#showcaseApp");
};


module.init = function () {
	module.addVueApp();
};

document.addEventListener("DOMContentLoaded", () => {
	module.init();
});
